import { useContext, useState, useEffect } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import "./CdTasinmazlar.css";
import { Link } from "react-router-dom";
import axios from "axios";

import { saveAs } from "file-saver";
import {
  AlignmentType,
  Document,
  BorderStyle,
  Packer,
  Paragraph,
  Table,
  TableRow,
  ImageRun,
  TableCell,
  VerticalAlign,
  WidthType,
  TextRun,
  PageBreak,
} from "docx";

const ignoreKeys = ["agaclar", "koyler", "ilceler", "munavebeDetay"];

export default function CdTasinmazlar() {
  const API_URL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_APIURL
      : "http://localhost:3000";

  const {
    user,
    userKredi,
    setUserKredi,
    agaclar,
    secilenSehir,
    mahkemeTuru,
    secilenIlce,
    dosyaYili,
    dosyaNo,
    dosyaTuru,
    davaci,
    davaciAvukati,
    davali,
    davaliAvukati,
    davaTuru,
    davaTarihi,
    kesifTarihi,
    tasinmazIller,
    tasinmazVasiflari,
    araziYapilari,
    toprakBunyeYapilari,
    munavebeler,
    setMunavebeler,
    tasinmazlar,
    setTasinmazlar,
    konumlar,
    setKonumlar,
    r1,
    setR1,
    r2,
    setR2,
    birinciBilirkisi,
    ikinciBilirkisi,
    ucuncuBilirkisi,
    dorduncuBilirkisi,
    besinciBilirkisi,
    altinciBilirkisi,
  } = useContext(GlobalContext);

  const dbdenMunavebeAl = (user) => {
    try {
      axios
        .post(API_URL + "/munavebegetir", { user })
        .then((response) => {
          console.log("Munavebeler :>> ", response);
          setMunavebeler(response.data);
        })
        .catch((error) => {
          alert("Bir Sorun var");
          console.error("There was an error!", error.data);
        });
    } catch (error) {}
  };

  useEffect(() => {
    munavebeler.length < 1 && dbdenMunavebeAl(user);
  }, []);

  const [isLoading, setIsLoading] = useState(false);

  const dt = davaTarihi
    ? davaTarihi.slice(8, 10) +
      "." +
      davaTarihi.slice(5, 7) +
      "." +
      davaTarihi.slice(0, 4)
    : ".../.../....";

  const kt = kesifTarihi
    ? kesifTarihi.slice(8, 10) +
      "." +
      kesifTarihi.slice(5, 7) +
      "." +
      kesifTarihi.slice(0, 4)
    : ".../.../....";

  const tasinmazEkle = () => {
    setTasinmazlar([
      ...tasinmazlar,
      {
        il: "",
        ilce: "",
        koy: "",
        ilceler: [],
        koyler: [],
        ada: "",
        parsel: "",
        m2: "",
        vasif: "",
        mevkii: "",
        araziyapisi: "Taban",
        toprakyapisi: "",
        egim: "1",
        kesiftekidurumu: "",
        konumozellikleri: "",
        kullanilacakMunavebe: "",
        munavebeDetay: [],
        masrafOrani: "Resmi Veri",
        oda: "0",
        malikler: "",
        agaclar: [],
      },
    ]);

    setKonumlar([...konumlar, ""]);
    setR1([...r1, ""]);
    setR2([...r2, ""]);
  };

  const tasinmazSil = (index) => {
    const list = [...tasinmazlar];
    list.splice(index, 1);
    setTasinmazlar(list);

    const konum = [...konumlar];
    konum.splice(index, 1);
    setKonumlar(konum);

    const rone = [...r1];
    rone.splice(index, 1);
    setR1(rone);

    const rtwo = [...r2];
    rtwo.splice(index, 1);
    setR2(rtwo);
  };

  const tasinmazDegistir = async (e, index) => {
    const { name, value } = e.target;

    const list = [...tasinmazlar];
    list[index][name] = value;

    if (name === "il") {
      list[index].ilce = "";
      list[index].koy = "";
      list[index].ilceler = [];
      list[index].koyler = [];

      const il = tasinmazIller.find((x) => x.name === value);

      if (il) {
        const response = await axios.get(
          `https://api.turkiyeapi.dev/v2/provinces/${il.id}/districts`,
        );
        list[index].ilceler = response.data.data;
      }
    }

    if (name === "ilce") {
      list[index].koy = "";
      list[index].koyler = [];

      const ilce = list[index].ilceler.find((x) => x.name === value);

      if (ilce) {
        const villagesRes = await axios.get(
          `https://api.turkiyeapi.dev/v2/districts/${ilce.id}/villages`,
        );
        const municipalitiesRes = await axios.get(
          `https://api.turkiyeapi.dev/v2/districts/${ilce.id}/municipalities`,
        );

        let mahalleler = [];

        for (const belediye of municipalitiesRes.data.data) {
          const response = await axios.get(
            `https://api.turkiyeapi.dev/v2/municipalities/${belediye.id}/neighborhoods`,
          );
          mahalleler.push(
            ...response.data.data.map((x) => ({
              ...x,
              type: "Mahallesi",
            })),
          );
        }

        const koyler = villagesRes.data.data.map((x) => ({
          ...x,
          type: "Köyü",
        }));

        list[index].koyler = [...koyler, ...mahalleler].sort((a, b) =>
          a.name.localeCompare(b.name, "tr"),
        );
      }
    }

    if (name === "kullanilacakMunavebe") {
      const selectedData = munavebeler.find(
        (item) => item.name === value,
      )?.data;
      list[index].munavebeDetay = selectedData ? JSON.parse(selectedData) : [];
    }

    setTasinmazlar(list);
  };

  const [newTree, setNewTree] = useState({
    adi: "",
    yasi: "",
    adeti: "",
    adetFiyati: "",
  });

  const handleTreeInputChange = (e) => {
    const { name, value } = e.target;
    setNewTree({ ...newTree, [name]: value });
    console.log("tasinmazlar :>> ", tasinmazlar);
  };

  const addTree = (index) => {
    const updatedData = tasinmazlar.map((item, i) => {
      if (i === index) {
        return { ...item, agaclar: [...item.agaclar, newTree] };
      }
      return item;
    });
    setTasinmazlar(updatedData);
    setNewTree({ adi: "", yasi: "", adeti: "", adetFiyati: "" });
  };

  const removeTree = (objectIndex, treeIndex) => {
    const updatedData = tasinmazlar.map((item, i) => {
      if (i === objectIndex) {
        return {
          ...item,
          agaclar: item.agaclar.filter((_, tIndex) => tIndex !== treeIndex),
        };
      }
      return item;
    });
    setTasinmazlar(updatedData);
  };

  const handleKonumUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedCards = [...konumlar];
        updatedCards[index] = reader.result;
        setKonumlar(updatedCards);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleR1Upload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedR1 = [...r1];
        updatedR1[index] = reader.result;
        setR1(updatedR1);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleR2Upload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedR2 = [...r2];
        updatedR2[index] = reader.result;
        setR2(updatedR2);
      };
      reader.readAsDataURL(file);
    }
  };

  const raporTarihi = new Date();
  const aylar = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  function hasEmptyProperties(obj) {
    const isEmpty = (value) =>
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0);

    function checkProperties(object) {
      for (const key in object) {
        if (!Object.prototype.hasOwnProperty.call(object, key)) continue;

        if (ignoreKeys.includes(key)) {
          continue;
        }

        const value = object[key];

        if (isEmpty(value)) {
          return true;
        }

        if (
          value !== null &&
          typeof value === "object" &&
          !Array.isArray(value)
        ) {
          if (checkProperties(value)) {
            return true;
          }
        }

        if (Array.isArray(value)) {
          for (const item of value) {
            if (item !== null && typeof item === "object") {
              if (checkProperties(item)) {
                return true;
              }
            }
          }
        }
      }
      return false;
    }

    return checkProperties(obj);
  }

  const reduceCredit = async () => {
    if (!user || !userKredi || isNaN(parseInt(userKredi, 10))) {
      window.alert("Geçerli bir kullanıcı ve kredi miktarı giriniz.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${API_URL}/reduce-credit`, {
        username: user,
        userKredi: parseInt(userKredi, 10),
      });

      if (response.data?.updatedKredi !== undefined) {
        setUserKredi(response.data.updatedKredi);
      }

      window.alert(response.data?.message || "İşlem başarılı.");
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        const errorMessage = data?.error || "Bilinmeyen bir hata oluştu.";

        if (status === 401) {
          window.alert("Yetkiniz yok.");
        } else if (status === 400) {
          window.alert("Geçersiz istek.");
        } else {
          window.alert(errorMessage);
        }
      } else {
        console.error("Hata:", error);
        window.alert("Bir hata oluştu. Lütfen tekrar deneyin.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const generateDocx = () => {
    if (userKredi > 0) {
      try {
        const doc = new Document({ sections: [] });

        // TÜM İÇERİĞİ TEK BİR ARRAY'DE TOPLA
        const allChildren = [];

        // ANA BAŞLIKLAR
        const anaBaslik =
          secilenIlce === "Merkez"
            ? new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "T.C. " + secilenSehir + " " + mahkemeTuru + "ne",
                    bold: true,
                    fontsize: 12,
                  }),
                ],
              })
            : new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "T.C. " + secilenIlce + " " + mahkemeTuru + "ne",
                    bold: true,
                    fontsize: 12,
                  }),
                ],
              });

        const altBaslik = new Paragraph({
          alignment: AlignmentType.CENTER,
          children: [
            new TextRun({
              text: "Bilirkişi Raporudur",
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const dosyaNumarasi = new Paragraph({
          alignment: AlignmentType.LEFT,
          children: [
            new TextRun({
              text: "Dosya No: " + dosyaYili + "/" + dosyaNo + " " + dosyaTuru,
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const davaciSatiri = new Paragraph({
          alignment: AlignmentType.LEFT,
          children: [
            new TextRun({
              text: mahkemeTuru.includes("Müdürlüğü")
                ? "Alacaklı: " + davaci
                : "Davacı: " + davaci,
              bold: true,
              fontsize: 12,
            }),
            davaciAvukati !== "--Seçiniz--"
              ? new TextRun({
                  text: " Vekili " + davaciAvukati,
                  bold: true,
                  fontsize: 12,
                })
              : new TextRun({
                  text: " ",
                  bold: true,
                  fontsize: 12,
                }),
          ],
        });

        const davaliSatiri = new Paragraph({
          alignment: AlignmentType.LEFT,
          children: [
            new TextRun({
              text: mahkemeTuru.includes("Müdürlüğü")
                ? "Borçlu: " + davali
                : "Davalı: " + davali,
              bold: true,
              fontsize: 12,
            }),
            davaliAvukati !== "--Seçiniz--"
              ? new TextRun({
                  text: " Vekili " + davaliAvukati,
                  bold: true,
                  fontsize: 12,
                })
              : new TextRun({
                  text: "",
                  bold: true,
                  fontsize: 12,
                }),
          ],
        });

        const davaKonusuSatiri = new Paragraph({
          alignment: AlignmentType.LEFT,
          children: [
            new TextRun({
              text: mahkemeTuru.includes("Müdürlüğü")
                ? "Talimat Konusu: " + davaTuru
                : "Dava Konusu: " + davaTuru,
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const davaTarihiSatiri = new Paragraph({
          alignment: AlignmentType.LEFT,
          children: [
            new TextRun({
              text: mahkemeTuru.includes("Müdürlüğü")
                ? "Talimat Tarihi: " + dt
                : "Dava Tarihi: " + dt,
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const kesifTarihiSatiri = new Paragraph({
          alignment: AlignmentType.LEFT,
          children: [
            new TextRun({
              text: "Keşif Tarihi: " + kt,
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const incelemeKonusuBasligi = new Paragraph({
          alignment: AlignmentType.BOTH,
          children: [
            new TextRun({
              text: "İnceleme Konusu:",
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const tasinmazListesi = tasinmazlar.map(
          (tasinmaz, index) =>
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    index +
                    1 +
                    ") " +
                    tasinmaz.il +
                    " İli " +
                    tasinmaz.ilce +
                    " İlçesi " +
                    tasinmaz.koy +
                    " " +
                    tasinmaz.ada +
                    " Ada " +
                    tasinmaz.parsel +
                    " Parsel Nolu " +
                    parseFloat(tasinmaz.m2).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) +
                    " m2 Yüzölçümüne Sahip " +
                    tasinmaz.vasif +
                    " Vasıflı Taşınmaz",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
        );

        const davaKonusuTalepBaslik = new Paragraph({
          alignment: AlignmentType.BOTH,
          children: [
            new TextRun({
              text: mahkemeTuru.includes("Müdürlüğü")
                ? "TALİMAT KONUSU VE TALEP"
                : "DAVA KONUSU ve TALEP",
              bold: true,
              fontsize: 12,
            }),
          ],
        });

        const davaKonusuTalepDetay = new Paragraph({
          alignment: AlignmentType.BOTH,
          children: [
            new TextRun({
              text:
                tasinmazlar.length > 1
                  ? "Dosyaya konu taşınmazların kıymet takdiri yapılması istenmiştir."
                  : "Dosyaya konu taşınmazın kıymet takdiri yapılması istenmiştir.",
              bold: false,
              fontsize: 12,
            }),
          ],
        });

        const bosParagraph = new Paragraph("");

        // BAŞLIKLARI EKLE
        allChildren.push(
          anaBaslik,
          altBaslik,
          dosyaNumarasi,
          davaciSatiri,
          davaliSatiri,
          davaKonusuSatiri,
          davaTarihiSatiri,
          kesifTarihiSatiri,
          incelemeKonusuBasligi,
          ...tasinmazListesi,
          davaKonusuTalepBaslik,
          davaKonusuTalepDetay,
          new Paragraph(""),
          new Paragraph(""),
        );

        // HER TAŞINMAZ İÇİN İÇERİK OLUŞTUR
        tasinmazlar.forEach((item, index) => {
          var toplamAgacFiyati = 0;
          item.agaclar.map((agac) => {
            return (toplamAgacFiyati =
              toplamAgacFiyati +
              parseFloat(agac.adeti) * parseFloat(agac.adetFiyati));
          });

          var toplamNetGelir = 0;
          item.masrafOrani === "Resmi Veri"
            ? item.munavebeDetay.map((urun) => {
                return (toplamNetGelir =
                  toplamNetGelir +
                  (parseFloat(urun.anaUrunVerim) *
                    parseFloat(urun.anaUrunFiyat) +
                    parseFloat(urun.yanUrunGelir) -
                    parseFloat(urun.masraf)));
              })
            : item.munavebeDetay.map((urun) => {
                return (toplamNetGelir =
                  toplamNetGelir +
                  (parseFloat(urun.anaUrunVerim) *
                    parseFloat(urun.anaUrunFiyat) +
                    parseFloat(urun.yanUrunGelir) -
                    (urun.anaUrunVerim * parseFloat(urun.anaUrunFiyat) +
                      parseFloat(urun.yanUrunGelir)) /
                      3));
              });

          var ortalamaNetGelir = 0;
          ortalamaNetGelir = (
            parseFloat(toplamNetGelir) / parseFloat(item.munavebeDetay.length)
          ).toFixed(2);

          var kfo = 0.05;
          item.araziyapisi === "Sulu" ? (kfo = 0.04) : (kfo = 0.05);

          var birDekarAraziDegeri = 0;
          birDekarAraziDegeri = (
            parseFloat(ortalamaNetGelir) / parseFloat(kfo)
          ).toFixed(2);
          var odaIlavesi = (
            ((parseFloat(ortalamaNetGelir) / parseFloat(kfo)) *
              parseFloat(item.oda)) /
            100
          ).toFixed(2);

          var odaEklenmisAraziDegeri = 0;
          odaEklenmisAraziDegeri =
            parseFloat(birDekarAraziDegeri) + parseFloat(odaIlavesi);
          var birM2AraziDegeri = (
            parseFloat(odaEklenmisAraziDegeri) / 1000
          ).toFixed(2);
          var tasinmazinZeminDegeri = (
            parseFloat(birM2AraziDegeri) * parseFloat(item.m2)
          ).toFixed(2);
          var tasinmazToplamDegeri = 0;
          tasinmazToplamDegeri = (
            parseFloat(tasinmazinZeminDegeri) + toplamAgacFiyati
          ).toFixed(2);

          // TAŞINMAZ BAŞLIĞI
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text:
                    index +
                    1 +
                    "- " +
                    item.koy.toUpperCase() +
                    " " +
                    item.ada +
                    " ADA " +
                    item.parsel +
                    " PARSEL NOLU TAŞINMAZ",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph(""),
          );

          // YÜZÖLÇÜMÜ
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "YÜZÖLÇÜMÜ:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text:
                    "Tapu Yüzölçümü: " +
                    parseFloat(item.m2).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) +
                    " m2'dir.",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph(""),
          );

          // TAŞINMAZ ÖZELLİKLERİ
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "TAŞINMAZ ÖZELLİKLERİ:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    "Taşınmazın vasfı tapu kaydına göre " +
                    item.vasif +
                    " olarak kayıtlıdır. " +
                    item.malikler +
                    " Keşif günü taşınmazın " +
                    item.araziyapisi +
                    " arazi vasfında olduğu görülmüştür. Bünye sınıfına göre toprak yapısının " +
                    item.toprakyapisi +
                    " olduğu, taşınmazın ortalama eğiminin %" +
                    item.egim +
                    " civarında olduğu görülmüştür. " +
                    item.kesiftekidurumu,
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph(""),
          );

          // AĞAÇLAR
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "TAŞINMAZ ÜZERİNDE BULUNAN DİKİLİ UNSURLAR:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
          );

          if (item.agaclar[0]) {
            const treeRows = [
              new TableRow({
                children: [
                  new TableCell({
                    borders: {
                      top: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    children: [
                      new Paragraph(
                        "Taşınmaz üzerinde aşağıda yaşı ve değerleri belirtilen ağaçlar mevcuttur.",
                      ),
                    ],
                    columnSpan: [5],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    borders: {
                      top: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    width: { size: 3505, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Ağaç Adı",
                            bold: true,
                            fontsize: 12,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    borders: {
                      top: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    width: { size: 3505, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Yaşı",
                            bold: true,
                            fontsize: 12,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    borders: {
                      top: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    width: { size: 3505, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Adet",
                            bold: true,
                            fontsize: 12,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    borders: {
                      top: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    width: { size: 3505, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Adet Fiyatı",
                            bold: true,
                            fontsize: 12,
                          }),
                        ],
                      }),
                    ],
                  }),
                  new TableCell({
                    borders: {
                      top: { style: BorderStyle.NONE },
                      left: { style: BorderStyle.NONE },
                      right: { style: BorderStyle.NONE },
                    },
                    width: { size: 3505, type: WidthType.DXA },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Toplam",
                            bold: true,
                            fontsize: 12,
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              ...item.agaclar.map((tree) => {
                return new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph(tree.adi)],
                    }),
                    new TableCell({
                      children: [new Paragraph(tree.yasi)],
                    }),
                    new TableCell({
                      children: [new Paragraph(tree.adeti)],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(tree.adetFiyati).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          (
                            parseFloat(tree.adetFiyati) * parseFloat(tree.adeti)
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        ),
                      ],
                    }),
                  ],
                });
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph("")],
                  }),
                  new TableCell({
                    children: [new Paragraph("")],
                  }),
                  new TableCell({
                    children: [new Paragraph("")],
                  }),
                  new TableCell({
                    children: [new Paragraph("Genel Toplam")],
                  }),
                  new TableCell({
                    children: [
                      new Paragraph(
                        toplamAgacFiyati.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }),
                      ),
                    ],
                  }),
                ],
              }),
            ];
            allChildren.push(new Table({ rows: treeRows }));
          } else {
            allChildren.push(
              new Paragraph(
                "Taşınmaz üzerinde ekonomik değeri olan ağaç bulunmamaktadır.",
              ),
            );
          }

          // KONUM
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "TAŞINMAZIN KONUM ÖZELLİKLERİ:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: item.konumozellikleri,
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "TAŞINMAZIN KONUMU",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
          );

          // KONUM RESMİ
          if (konumlar[index]) {
            allChildren.push(
              new Paragraph({
                children: [
                  new ImageRun({
                    type: "jpg" || "png",
                    data: konumlar[index],
                    transformation: {
                      width: 600,
                      height: 250,
                    },
                  }),
                ],
              }),
            );
          }

          // TAŞINMAZ RESİMLERİ
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "TAŞINMAZ RESİMLERİ",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
          );

          // RESİMLER
          const imageChildren = [];
          if (r1[index]) {
            imageChildren.push(
              new ImageRun({
                type: "jpg" || "png",
                data: r1[index],
                transformation: {
                  width: 280,
                  height: 180,
                },
              }),
            );
          }
          if (r2[index]) {
            if (imageChildren.length > 0) {
              imageChildren.push(
                new TextRun({
                  text: "     ",
                  bold: true,
                  fontsize: 12,
                }),
              );
            }
            imageChildren.push(
              new ImageRun({
                type: "jpg" || "png",
                data: r2[index],
                transformation: {
                  width: 280,
                  height: 180,
                },
              }),
            );
          }

          if (imageChildren.length > 0) {
            allChildren.push(
              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: imageChildren,
              }),
            );
          }

          allChildren.push(new Paragraph(""));

          // DEĞER HESAPLAMASI
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "TAŞINMAZIN DEĞERİNİN HESAPLANMASI:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "a- Kapitalizasyon Faiz Oranı:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    item.araziyapisi === "Sulu"
                      ? "Kapitalizasyon Faiz Oranına yönelik hesaplamalarda yörede mevcut satışı yapılan alanlardaki değerlendirmeler, taşınmazın Sulu arazi olması da değerlendirilerek elde edilen kapitalizasyon faiz oranı %4 olarak kabul görmüştür."
                      : "Kapitalizasyon Faiz Oranına yönelik hesaplamalarda yörede mevcut satışı yapılan alanlardaki değerlendirmeler, taşınmazın Kuru arazi olması da değerlendirilerek elde edilen kapitalizasyon faiz oranı %5 olarak kabul görmüştür.",
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "b- Objektif Değer Artışı:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    parseFloat(item.oda) > 0
                      ? "Taşınmazın konum ve diğer özelliklerinde belirtilen sebepler ile taşınmazın etrafında bulunan köylerin nüfus yoğunluğu ile tarıma olan ilginin fazla olması gibi sebeplerden dolayı taşınmazın değerine %" +
                        item.oda +
                        " oranında objektif değer artış oranı eklenmesi kanaati oluşmuştur."
                      : "Keşif günü taşınmazın ulaşım, kullanım ve diğer özellikleri dikkate alındığında taşınmazın değerine objektif değer artışı eklemesine gerek görülmemiştir.",
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text: "c- Net Gelirin Hesaplanması Taşınmazın Çıplak Arazi Değeri:",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text: mahkemeTuru.includes("Müdürlüğü")
                    ? "Taşınmazın değeri hesaplanırken, taşınmazın toprak ve mevkii durumuna göre taşınmazın bulunduğu ilçedeki resmi verilere dayanılarak aşağıdaki münavebenin kullanılması uygun görülmüştür."
                    : "Taşınmazın değeri hesaplanırken, taşınmazın toprak ve mevkii durumuna göre taşınmazın bulunduğu ilçedeki dava yılında geçerli resmi verilere dayanılarak aşağıdaki münavebenin kullanılması uygun görülmüştür.",
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    dosyaYili +
                    " Yılı " +
                    item.araziyapisi +
                    " Arazi" +
                    item.munavebeDetay.map((x) => {
                      return " " + x.urunAdi;
                    }),
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    item.masrafOrani === "Ucte Bir"
                      ? "(Resmi veriler incelendiğinde üretim masrafı oranlarının fahiş olduğu görüldüğünden masraf değeri olarak münavebeye giren ürünlerin brüt gelirlerinin 1/3'ü alınmıştır.)"
                      : "Üretim masrafları için resmi verilerdeki değerler kullanılmıştır.",
                  bold: false,
                  fontsize: 12,
                }),
              ],
            }),
          );

          // MÜNAVEBE TABLOSU
          const munavebeHeaders = [
            new TableRow({
              children: [
                new TableCell({
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Ürün Adı",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Verim",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Fiyat",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Yan Ürün Gelir",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Masraf",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "Net Gelir",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
          ];

          if (item.masrafOrani === "Resmi Veri") {
            const rows = [
              ...munavebeHeaders,
              ...item.munavebeDetay.map((urun) => {
                return new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph(urun.urunAdi)],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.anaUrunVerim).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.anaUrunFiyat).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.yanUrunGelir).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.masraf).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          (
                            parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                            parseFloat(urun.yanUrunGelir) -
                            parseFloat(urun.masraf)
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        ),
                      ],
                    }),
                  ],
                });
              }),
            ];
            allChildren.push(new Table({ rows }));
          } else {
            const rows = [
              ...munavebeHeaders,
              ...item.munavebeDetay.map((urun) => {
                return new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph(urun.urunAdi)],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.anaUrunVerim).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.anaUrunFiyat).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          parseFloat(urun.yanUrunGelir).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          ),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          (
                            (parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                              parseFloat(urun.yanUrunGelir)) /
                            3
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        ),
                      ],
                    }),
                    new TableCell({
                      children: [
                        new Paragraph(
                          (
                            parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                            parseFloat(urun.yanUrunGelir) -
                            (parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                              parseFloat(urun.yanUrunGelir)) /
                              3
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        ),
                      ],
                    }),
                  ],
                });
              }),
            ];
            allChildren.push(new Table({ rows }));
          }

          // ORTALAMA NET GELİR
          if (item.masrafOrani !== "Resmi Veri") {
            allChildren.push(
              new Paragraph({
                alignment: AlignmentType.BOTH,
                children: [
                  new TextRun({
                    text: "Ortalama Net Gelir = ",
                    bold: true,
                    fontsize: 12,
                  }),
                  new TextRun({
                    text:
                      "(" +
                      item.munavebeDetay
                        .map((urun) =>
                          (
                            parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                            parseFloat(urun.yanUrunGelir) -
                            (parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                              parseFloat(urun.yanUrunGelir)) /
                              3
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        )
                        .join("+") +
                      ")/" +
                      item.munavebeDetay.length.toString() +
                      " =",
                    bold: true,
                    fontsize: 12,
                  }),
                  new TextRun({
                    text:
                      " " +
                      parseFloat(ortalamaNetGelir).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) +
                      " TL/da'dır.",
                    bold: true,
                    fontsize: 11,
                  }),
                ],
              }),
            );
          } else {
            allChildren.push(
              new Paragraph({
                alignment: AlignmentType.BOTH,
                children: [
                  new TextRun({
                    text: "Ortalama Net Gelir = ",
                    bold: false,
                    fontsize: 12,
                  }),
                  new TextRun({
                    text:
                      "(" +
                      item.munavebeDetay
                        .map((urun) =>
                          (
                            parseFloat(urun.anaUrunVerim) *
                              parseFloat(urun.anaUrunFiyat) +
                            parseFloat(urun.yanUrunGelir) -
                            parseFloat(urun.masraf)
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }),
                        )
                        .join("+") +
                      ")/" +
                      item.munavebeDetay.length.toString(),
                    bold: true,
                    fontsize: 12,
                  }),
                  new TextRun({
                    text:
                      " = " +
                      parseFloat(ortalamaNetGelir).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) +
                      " TL/da'dır.",
                    bold: true,
                    fontsize: 11,
                  }),
                ],
              }),
            );
          }

          // BİR DEKAR ARAZİ DEĞERİ
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                parseFloat(item.oda) > 0
                  ? new TextRun({
                      text: "Bir Dekar Arazi Değeri = (Ortalama Net Gelir / Kapitalizasyon Faiz Oranı) + (Objektif Değer Artışı)",
                      bold: false,
                      fontsize: 11,
                    })
                  : new TextRun({
                      text: "Bir Dekar Arazi Değeri = (Ortalama Net Gelir / Kapitalizasyon Faiz Oranı) ",
                      bold: false,
                      fontsize: 11,
                    }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                parseFloat(item.oda) > 0
                  ? new TextRun({
                      text:
                        "Bir Dekar Arazi Değeri = (" +
                        parseFloat(ortalamaNetGelir).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        "/" +
                        kfo.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        ") + ((" +
                        parseFloat(ortalamaNetGelir).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        "/" +
                        kfo.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        ") X " +
                        parseFloat(item.oda / 100).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        ")",
                      bold: false,
                      fontsize: 11,
                    })
                  : new TextRun({
                      text:
                        "Bir Dekar Arazi Değeri = (" +
                        parseFloat(ortalamaNetGelir).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        "/" +
                        kfo.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        ")",
                      bold: false,
                      fontsize: 11,
                    }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                parseFloat(item.oda) > 0
                  ? new TextRun({
                      text:
                        "Bir Dekar Arazi Değeri = " +
                        parseFloat(birDekarAraziDegeri).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        ) +
                        " + " +
                        parseFloat(odaIlavesi).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " = " +
                        parseFloat(odaEklenmisAraziDegeri).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        ) +
                        " TL/da'dır.",
                      bold: false,
                      fontsize: 11,
                    })
                  : new TextRun({
                      text:
                        "Bir Dekar Arazi Değeri = " +
                        parseFloat(odaEklenmisAraziDegeri).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        ) +
                        " TL/da'dır.",
                      bold: false,
                      fontsize: 11,
                    }),
              ],
            }),
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    "Bir M2 Arazi Değeri = " +
                    parseFloat(birM2AraziDegeri).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) +
                    " TL/m2'dir.",
                  bold: false,
                  fontsize: 11,
                }),
              ],
            }),
          );

          // ZEMİN DEĞERİ - HER ZAMAN GÖSTER
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    "Taşınmazın Zemin Değeri = " +
                    parseFloat(birM2AraziDegeri).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) +
                    " TL/m2 X " +
                    parseFloat(item.m2).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) +
                    " m2 = " +
                    parseFloat(tasinmazinZeminDegeri).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    ) +
                    " TL'dir.",
                  bold: false,
                  fontsize: 11,
                }),
              ],
            }),
          );

          // TOPLAM DEĞER - AĞAÇ DURUMUNA GÖRE
          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.BOTH,
              children: [
                new TextRun({
                  text:
                    toplamAgacFiyati > 0
                      ? "Taşınmazın Toplam Değeri = " +
                        parseFloat(tasinmazinZeminDegeri).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        ) +
                        " + " +
                        parseFloat(toplamAgacFiyati).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " = " +
                        parseFloat(tasinmazToplamDegeri).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        ) +
                        " TL'dir."
                      : "Taşınmazın Toplam Değeri = " +
                        parseFloat(tasinmazToplamDegeri).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        ) +
                        " TL'dir.",
                  bold: false,
                  fontsize: 11,
                }),
              ],
            }),
          );

          // HER TAŞINMAZDAN SONRA SAYFA SONU EKLE (SON TAŞINMAZ HARİÇ)
          if (index < tasinmazlar.length - 1) {
            allChildren.push(new Paragraph({ children: [new PageBreak()] }));
          }
        });

        // SONUÇ BÖLÜMÜ - YENİ SAYFA
        allChildren.push(new Paragraph({ children: [new PageBreak()] }));

        const sonucBaslik = new Paragraph({
          alignment: AlignmentType.BOTH,
          children: [
            new TextRun({
              text: "SONUÇ OLARAK:",
              bold: true,
              fontsize: 11,
            }),
          ],
        });

        const sonucDetay = new Paragraph({
          alignment: AlignmentType.BOTH,
          children: [
            mahkemeTuru.includes("Müdürlüğü")
              ? new TextRun({
                  text: "Keşif tarihi itibarı ile yapılan hesaplamalar neticesinde;",
                  bold: false,
                  fontsize: 11,
                })
              : new TextRun({
                  text: "Dava tarihi itibarı ile yapılan hesaplamalar neticesinde;",
                  bold: false,
                  fontsize: 11,
                }),
          ],
        });

        allChildren.push(sonucBaslik, sonucDetay);

        // TAŞINMAZ DEĞER ÖZETLERİ
        tasinmazlar.forEach((item, index) => {
          var toplamAgacFiyati = 0;
          item.agaclar.map((agac) => {
            return (toplamAgacFiyati =
              toplamAgacFiyati +
              parseFloat(agac.adeti) * parseFloat(agac.adetFiyati));
          });

          var toplamNetGelir = 0;
          item.masrafOrani === "Resmi Veri"
            ? item.munavebeDetay.map((urun) => {
                return (toplamNetGelir =
                  toplamNetGelir +
                  (parseFloat(urun.anaUrunVerim) *
                    parseFloat(urun.anaUrunFiyat) +
                    parseFloat(urun.yanUrunGelir) -
                    parseFloat(urun.masraf)));
              })
            : item.munavebeDetay.map((urun) => {
                return (toplamNetGelir =
                  toplamNetGelir +
                  (parseFloat(urun.anaUrunVerim) *
                    parseFloat(urun.anaUrunFiyat) +
                    parseFloat(urun.yanUrunGelir) -
                    (urun.anaUrunVerim * parseFloat(urun.anaUrunFiyat) +
                      parseFloat(urun.yanUrunGelir)) /
                      3));
              });

          var ortalamaNetGelir = 0;
          ortalamaNetGelir = (
            parseFloat(toplamNetGelir) / parseFloat(item.munavebeDetay.length)
          ).toFixed(2);

          var kfo = 0.05;
          item.araziyapisi === "Sulu" ? (kfo = 0.04) : (kfo = 0.05);

          var birDekarAraziDegeri = 0;
          birDekarAraziDegeri = (
            parseFloat(ortalamaNetGelir) / parseFloat(kfo)
          ).toFixed(2);
          var odaIlavesi = (
            ((parseFloat(ortalamaNetGelir) / parseFloat(kfo)) *
              parseFloat(item.oda)) /
            100
          ).toFixed(2);

          var odaEklenmisAraziDegeri = 0;
          odaEklenmisAraziDegeri =
            parseFloat(birDekarAraziDegeri) + parseFloat(odaIlavesi);
          var birM2AraziDegeri = (
            parseFloat(odaEklenmisAraziDegeri) / 1000
          ).toFixed(2);
          var tasinmazinZeminDegeri = (
            parseFloat(birM2AraziDegeri) * parseFloat(item.m2)
          ).toFixed(2);
          var tasinmazToplamDegeri = 0;
          tasinmazToplamDegeri = (
            parseFloat(tasinmazinZeminDegeri) + toplamAgacFiyati
          ).toFixed(2);

          allChildren.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [
                new TextRun({
                  text:
                    index +
                    1 +
                    "- " +
                    item.ada +
                    " ADA " +
                    item.parsel +
                    " PARSEL NOLU TAŞINMAZ: " +
                    parseFloat(tasinmazToplamDegeri).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) +
                    " TL'dir.",
                  bold: true,
                  fontsize: 12,
                }),
              ],
            }),
          );
        });

        // BİLİRKİŞİ TABLOSU
        const bilirkisiTablosu = new Table({
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                 borders: {
                                             top: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "FF0000",
                                             },
                                             bottom: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "0000FF",
                                             },
                                             left: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "00FF00",
                                             },
                                             right: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "#ff8000",
                                             },
                                           },
                  width: { size: 3505, type: WidthType.DXA },
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: ikinciBilirkisi ? ikinciBilirkisi[0].name : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: ikinciBilirkisi
                            ? ikinciBilirkisi[0].bilirkisiUnvani
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: ikinciBilirkisi
                            ? "Sicil No: " + ikinciBilirkisi[0].bilirkisiSicilNo
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  borders: {
                                              top: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "FF0000",
                                              },
                                              bottom: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "0000FF",
                                              },
                                              left: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "00FF00",
                                              },
                                              right: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "#ff8000",
                                              },
                                            },
                  width: { size: 3505, type: WidthType.DXA },
                  
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      borders: {
                                                  top: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "FF0000",
                                                  },
                                                  bottom: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "0000FF",
                                                  },
                                                  left: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "00FF00",
                                                  },
                                                  right: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "#ff8000",
                                                  },
                                                },
                      children: [
                        new TextRun({
                          text: ucuncuBilirkisi ? ucuncuBilirkisi[0].name : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      borders: {
                                                  top: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "FF0000",
                                                  },
                                                  bottom: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "0000FF",
                                                  },
                                                  left: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "00FF00",
                                                  },
                                                  right: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "#ff8000",
                                                  },
                                                },
                      children: [
                        new TextRun({
                          text: ucuncuBilirkisi
                            ? ucuncuBilirkisi[0].bilirkisiUnvani
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      borders: {
                                                  top: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "FF0000",
                                                  },
                                                  bottom: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "0000FF",
                                                  },
                                                  left: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "00FF00",
                                                  },
                                                  right: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "#ff8000",
                                                  },
                                                },
                      children: [
                        new TextRun({
                          text: ucuncuBilirkisi
                            ? "Sicil No: " + ucuncuBilirkisi[0].bilirkisiSicilNo
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  borders: {
                                              top: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "FF0000",
                                              },
                                              bottom: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "0000FF",
                                              },
                                              left: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "00FF00",
                                              },
                                              right: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "#ff8000",
                                              },
                                            },
                  width: { size: 3505, type: WidthType.DXA },
                  
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      borders: {
                                                  top: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "FF0000",
                                                  },
                                                  bottom: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "0000FF",
                                                  },
                                                  left: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "00FF00",
                                                  },
                                                  right: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "#ff8000",
                                                  },
                                                },
                      children: [
                        new TextRun({
                          text: birinciBilirkisi
                            ? birinciBilirkisi[0].name
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      borders: {
                                                  top: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "FF0000",
                                                  },
                                                  bottom: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "0000FF",
                                                  },
                                                  left: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "00FF00",
                                                  },
                                                  right: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "#ff8000",
                                                  },
                                                },
                      children: [
                        new TextRun({
                          text: birinciBilirkisi
                            ? birinciBilirkisi[0].bilirkisiUnvani
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      borders: {
                                                  top: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "FF0000",
                                                  },
                                                  bottom: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "0000FF",
                                                  },
                                                  left: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "00FF00",
                                                  },
                                                  right: {
                                                    style: BorderStyle.NONE,
                                                    size: 3,
                                                    color: "#ff8000",
                                                  },
                                                },
                      children: [
                        new TextRun({
                          text: birinciBilirkisi
                            ? "Sicil No: " +
                              birinciBilirkisi[0].bilirkisiSicilNo
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
            new TableRow({
              children: [
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
              borders: {
                                          top: {
                                            style: BorderStyle.NONE,
                                            size: 3,
                                            color: "FF0000",
                                          },
                                          bottom: {
                                            style: BorderStyle.NONE,
                                            size: 3,
                                            color: "0000FF",
                                          },
                                          left: {
                                            style: BorderStyle.NONE,
                                            size: 3,
                                            color: "00FF00",
                                          },
                                          right: {
                                            style: BorderStyle.NONE,
                                            size: 3,
                                            color: "#ff8000",
                                          },
                                        },
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: besinciBilirkisi
                            ? besinciBilirkisi[0].name
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: besinciBilirkisi
                            ? besinciBilirkisi[0].bilirkisiUnvani
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: besinciBilirkisi
                            ? "Sicil No: " +
                              besinciBilirkisi[0].bilirkisiSicilNo
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                 borders: {
                                             top: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "FF0000",
                                             },
                                             bottom: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "0000FF",
                                             },
                                             left: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "00FF00",
                                             },
                                             right: {
                                               style: BorderStyle.NONE,
                                               size: 3,
                                               color: "#ff8000",
                                             },
                                           },
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: dorduncuBilirkisi
                            ? dorduncuBilirkisi[0].name
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: dorduncuBilirkisi
                            ? dorduncuBilirkisi[0].bilirkisiUnvani
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: dorduncuBilirkisi
                            ? "Sicil No: " +
                              dorduncuBilirkisi[0].bilirkisiSicilNo
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  borders: {
                                              top: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "FF0000",
                                              },
                                              bottom: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "0000FF",
                                              },
                                              left: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "00FF00",
                                              },
                                              right: {
                                                style: BorderStyle.NONE,
                                                size: 3,
                                                color: "#ff8000",
                                              },
                                            },
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: altinciBilirkisi
                            ? altinciBilirkisi[0].name
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: altinciBilirkisi
                            ? altinciBilirkisi[0].bilirkisiUnvani
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text: altinciBilirkisi
                            ? "Sicil No: " +
                              altinciBilirkisi[0].bilirkisiSicilNo
                            : "",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
          ],
        });

        const kapanisParagrafi = new Paragraph({
          alignment: AlignmentType.BOTH,
          children: [
            mahkemeTuru.includes("Müdürlüğü")
              ? new TextRun({
                  text:
                    "Görüş ve kanaatimi içeren iş bu bilirkişi raporunu Nihai Takdir Müdürlüğünüze ait olmak üzere saygılarımla arz ederim. " +
                    raporTarihi.getDate() +
                    "." +
                    aylar[raporTarihi.getMonth()] +
                    "." +
                    raporTarihi.getFullYear(),
                  bold: false,
                  fontsize: 11,
                })
              : new TextRun({
                  text:
                    "Görüş ve kanaatimi içeren iş bu bilirkişi raporunu Nihai Takdir Mahkemenize ait olmak üzere saygılarımla arz ederim." +
                    raporTarihi.getDate() +
                    "." +
                    aylar[raporTarihi.getMonth()] +
                    "." +
                    raporTarihi.getFullYear(),
                  bold: false,
                  fontsize: 11,
                }),
          ],
        });

        allChildren.push(kapanisParagrafi, bosParagraph, bilirkisiTablosu);

        // TEK SECTION İLE BELGEYİ OLUŞTUR
        doc.addSection({
          children: allChildren,
        });

        // Word dosyasını oluştur ve indir
        if (hasEmptyProperties(tasinmazlar)) {
          console.log(JSON.stringify(tasinmazlar[0], null, 2));
          alert("Tüm Alanları Doldurunuz.");
        } else {
          Packer.toBlob(doc).then((blob) => {
            saveAs(blob, "taşınmaz_bilgileri.docx");
          });
        }

        if (!hasEmptyProperties(tasinmazlar)) {
          reduceCredit();
        }
      } catch (error) {
        window.alert("Bir Sorun Oluştu.");
        console.error(error);
      }
    } else {
      window.alert("Krediniz Kalmadı. Lütfen Bağış Yapınız :(");
    }
  };

  // JSX return kısmı aynı kalıyor...
  return (
    <>
      <GlobalProvider>
        <div className="container">
          <div className="row my-5 text-center">
            <h1 className="text-primary">Dava Konusu Taşınmaz Bilgileri</h1>
          </div>

          <div className="row">
            {tasinmazlar.map((tasinmaz, index) => (
              <div key={index} className="card mb-3 shadow-sm">
                <div className="card-body">
                  <h2 className="card-title text-center text-primary">
                    <h1>TAŞINMAZ #{index + 1}</h1>
                  </h2>
                  <div className="row">
                    <div className="col-4">
                      <label
                        htmlFor={`il-${index}`}
                        className="form-label  text-danger"
                      >
                        Taşınmazın İli
                      </label>
                      <select
                        className="form-select"
                        name="il"
                        value={tasinmaz.il}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      >
                        <option value="">--Seçiniz--</option>

                        {tasinmazIller.map((deger) => (
                          <option key={deger.id} value={deger.name}>
                            {deger.name}
                          </option>
                        ))}
                      </select>

                      <label
                        htmlFor={`ilce-${index}`}
                        className="form-label  text-danger"
                      >
                        Taşınmazın İlçesi
                      </label>
                      <select
                        className="form-select"
                        name="ilce"
                        value={tasinmaz.ilce}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      >
                        <option value="">--Seçiniz--</option>

                        {(tasinmaz.ilceler || []).map((deger) => (
                          <option key={deger.id} value={deger.name}>
                            {deger.name}
                          </option>
                        ))}
                      </select>

                      <label
                        htmlFor={`koy-${index}`}
                        className="form-label  text-danger"
                      >
                        Köy/Mahalle
                      </label>
                      <select
                        name="koy"
                        className="form-select"
                        value={tasinmaz.koy}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      >
                        <option>--Seçiniz--</option>

                        {(tasinmaz.koyler || []).map((item) => (
                          <option
                            key={item.id}
                            value={`${item.name} ${item.type}`}
                          >
                            {item.name} {item.type}
                          </option>
                        ))}
                      </select>

                      <label
                        htmlFor={`ada-${index}`}
                        className="form-label  text-danger"
                      >
                        Ada No
                      </label>
                      <input
                        id={`ada-${index}`}
                        name="ada"
                        type="text"
                        className="form-control"
                        placeholder="Ada No"
                        value={tasinmazlar[index].ada || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      />
                      <label
                        htmlFor={`parsel-${index}`}
                        className="form-label  text-danger"
                      >
                        Parsel No
                      </label>
                      <input
                        id={`parsel-${index}`}
                        name="parsel"
                        type="number"
                        className="form-control"
                        placeholder="Parsel"
                        value={tasinmazlar[index].parsel || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      />
                      <label
                        htmlFor={`m2-${index}`}
                        className="form-label  text-danger"
                      >
                        Taşınmaz Alanı
                      </label>
                      <input
                        id={`m2-${index}`}
                        name="m2"
                        type="number"
                        className="form-control"
                        placeholder="Taşınmaz Alanı"
                        value={tasinmazlar[index].m2 || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      />
                      <label
                        htmlFor={`vasif-${index}`}
                        className="form-label  text-danger"
                      >
                        Taşınmaz Vasfı
                      </label>
                      <select
                        id={`vasif-${index}`}
                        className="form-select"
                        name={`vasif`}
                        onChange={(e) => tasinmazDegistir(e, index)}
                        value={tasinmazlar && tasinmazlar[index].vasif}
                      >
                        <option defaultValue>--Seçiniz--</option>

                        {tasinmazVasiflari
                          ? tasinmazVasiflari.map((deger) => (
                              <option key={deger.id}>{deger.name}</option>
                            ))
                          : ""}
                      </select>
                      <label
                        htmlFor={`mevkii-${index}`}
                        className="form-label text-danger"
                      >
                        Taşınmaz Mevkii
                      </label>
                      <input
                        id={`mevkii-${index}`}
                        name="mevkii"
                        type="text"
                        className="form-control"
                        placeholder="Taşınmaz mevkii"
                        value={tasinmazlar[index].mevkii || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      />
                    </div>
                    <div className="col-4">
                      <label
                        htmlFor={`araziyapisi-${index}`}
                        className="form-label  text-danger"
                      >
                        Arazi Yapısı
                      </label>
                      <select
                        id={`araziyapisi-${index}`}
                        className="form-select"
                        name={`araziyapisi`}
                        onChange={(e) => tasinmazDegistir(e, index)}
                        value={tasinmazlar && tasinmazlar[index].araziyapisi}
                      >
                        <option defaultValue>--Seçiniz--</option>

                        {araziYapilari
                          ? araziYapilari.map((deger) => (
                              <option key={deger.id}>{deger.name}</option>
                            ))
                          : ""}
                      </select>

                      <label
                        htmlFor={`toprakyapisi-${index}`}
                        className="form-label  text-danger"
                      >
                        Toprak Yapısı
                      </label>
                      <select
                        id={`toprakyapisi-${index}`}
                        className="form-select"
                        name={`toprakyapisi`}
                        onChange={(e) => tasinmazDegistir(e, index)}
                        value={tasinmazlar && tasinmazlar[index].toprakyapisi}
                      >
                        <option defaultValue>--Seçiniz--</option>

                        {toprakBunyeYapilari
                          ? toprakBunyeYapilari.map((deger) => (
                              <option key={deger.id}>{deger.name}</option>
                            ))
                          : ""}
                      </select>

                      <label
                        htmlFor={`egim-${index}`}
                        className="form-label  text-danger"
                      >
                        Ortalama Eğim
                      </label>
                      <input
                        id={`egim-${index}`}
                        name="egim"
                        type="text"
                        className="form-control"
                        placeholder="Eğim %"
                        value={tasinmazlar[index].egim || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                      />

                      <label
                        htmlFor={`kesiftekidurumu-${index}`}
                        className="form-label  text-danger"
                      >
                        Keşifte Görülenler
                      </label>
                      <textarea
                        id={`kesiftekidurumu-${index}`}
                        name="kesiftekidurumu"
                        type="text"
                        className="form-control"
                        placeholder="Taşınmazın Keşifte Görülen Ekstra Özelliklerini Anlatınız."
                        value={tasinmazlar[index].kesiftekidurumu || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                        style={{ height: "108px" }}
                      />

                      <label
                        htmlFor={`konumozellikleri-${index}`}
                        className="form-label  text-danger"
                      >
                        Taşınmazın Konumu
                      </label>
                      <textarea
                        id={`konumozellikleri-${index}`}
                        name="konumozellikleri"
                        type="text"
                        className="form-control"
                        placeholder="Önemli yerlere olan mesafeleri yazınız."
                        value={tasinmazlar[index].konumozellikleri || ""}
                        onChange={(e) => tasinmazDegistir(e, index)}
                        style={{ height: "108px" }}
                      />
                    </div>
                    <div className="col-4">
                      <div className="row">
                        <label
                          htmlFor={`kullanilacakMunavebe-${index}`}
                          className="form-label  text-danger"
                        >
                          Kullanılacak Münavebe
                        </label>

                        <select
                          id={`kullanilacakMunavebe-${index}`}
                          className="form-select"
                          name={`kullanilacakMunavebe`}
                          onChange={(e) => tasinmazDegistir(e, index)}
                          value={
                            tasinmazlar &&
                            tasinmazlar[index].kullanilacakMunavebe
                          }
                        >
                          <option defaultValue>--Seçiniz--</option>

                          {munavebeler &&
                            munavebeler.map((deger) => (
                              <option key={deger.id}>{deger.name}</option>
                            ))}
                        </select>
                        <label
                          htmlFor={`masrafOrani-${index}`}
                          className="form-label  text-danger"
                        >
                          Masraf Oranı
                        </label>
                        <select
                          id={`masrafOrani-${index}`}
                          className="form-select"
                          name={`masrafOrani`}
                          onChange={(e) => tasinmazDegistir(e, index)}
                          value={tasinmazlar && tasinmazlar[index].masrafOrani}
                        >
                          <option key="seciniz" defaultValue>
                            --Seçiniz--
                          </option>
                          <option
                            key="Resmi Veri"
                            id="Resmi Veri"
                            value="Resmi Veri"
                          >
                            Resmi Veri
                          </option>
                          <option key="Ucte Bir" id="Ucte Bir" value="Ucte Bir">
                            Üçte Bir
                          </option>
                        </select>
                        <label
                          htmlFor={`oda-${index}`}
                          className="form-label  text-danger"
                        >
                          Objektif Değer Artışı %
                        </label>
                        <input
                          id={`oda-${index}`}
                          name="oda"
                          type="text"
                          className="form-control"
                          placeholder="Objektif Değer Artışı %"
                          value={tasinmazlar[index].oda || ""}
                          onChange={(e) => tasinmazDegistir(e, index)}
                        />
                        <label
                          htmlFor={`malikler-${index}`}
                          className="form-label  text-danger"
                        >
                          Taşınmaz Malikleri ve Hisse Oranları
                        </label>
                        <textarea
                          id={`malikler-${index}`}
                          name="malikler"
                          type="text"
                          className="form-control"
                          placeholder="Taşınmaz Malikleri ve Hisse Oranları"
                          value={tasinmazlar[index].malikler || ""}
                          onChange={(e) => tasinmazDegistir(e, index)}
                          style={{ height: "108px" }}
                        />
                      </div>
                    </div>
                    <div className="row mt-5">
                      <h1>TAŞINMAZA İLİŞKİN RESİMLER</h1>
                      <div className="col">
                        <div
                          style={{
                            marginTop: "5px",
                            border: "solid 1px",
                            borderRadius: "5px",
                          }}
                        >
                          <h4>Konum Resmi Seçiniz</h4>
                          {konumlar[index] && (
                            <div className="preview-container">
                              <img
                                className="mx-2"
                                name="konum"
                                src={konumlar[index]}
                                alt="Yüklenen Konum Resmi"
                                style={{
                                  maxWidth: "90%",
                                  maxHeight: "150px",
                                }}
                              />
                            </div>
                          )}
                          <label
                            htmlFor={`konumResmi-${index}`}
                            className="custom-file-upload my-2"
                          >
                            Resim Yükle
                            <input
                              id={`konumResmi-${index}`}
                              name="konum"
                              type="file"
                              onChange={(e) => handleKonumUpload(e, index)}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                      </div>
                      <div
                        className="col"
                        style={{
                          marginTop: "5px",
                          border: "solid 1px",
                          borderRadius: "5px",
                        }}
                      >
                        <div>
                          <h4>1. Taşınmaz Resmi Seçiniz</h4>
                          {r1[index] && (
                            <div className="preview-container">
                              <img
                                className="mx-2"
                                name="resim1"
                                src={r1[index]}
                                alt="Yüklenen 1. Resim"
                                style={{
                                  maxWidth: "90%",
                                  maxHeight: "150px",
                                }}
                              />
                            </div>
                          )}
                          <label
                            htmlFor={`resim1-${index}`}
                            className="custom-file-upload my-2"
                          >
                            Resim Yükle
                            <input
                              id={`resim1-${index}`}
                              name="resim1"
                              type="file"
                              onChange={(e) => handleR1Upload(e, index)}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          style={{
                            marginTop: "5px",
                            border: "solid 1px",
                            borderRadius: "5px",
                          }}
                        >
                          <h4>2. Taşınmaz Resmi Seçiniz</h4>
                          {r2[index] && (
                            <div className="preview-container">
                              <img
                                className="mx-2"
                                name="resim2"
                                src={r2[index]}
                                alt="Yüklenen 2. Resim"
                                style={{
                                  maxWidth: "90%",
                                  maxHeight: "150px",
                                }}
                              />
                            </div>
                          )}
                          <label
                            htmlFor={`resim2-${index}`}
                            className="custom-file-upload my-2"
                          >
                            Resim Yükle
                            <input
                              id={`resim2-${index}`}
                              name="resim2"
                              type="file"
                              onChange={(e) => handleR2Upload(e, index)}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div>
                        <h4>Meyve Ağaçları</h4>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Adı</th>
                              <th>Yaşı</th>
                              <th>Adeti</th>
                              <th>Adet Fiyatı</th>
                              <th>İşlemler</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tasinmaz.agaclar.map((tree, treeIndex) => (
                              <tr key={treeIndex}>
                                <td>{tree.adi}</td>
                                <td>{tree.yasi}</td>
                                <td>{tree.adeti}</td>
                                <td>{tree.adetFiyati}</td>

                                <td>
                                  <button
                                    onClick={() => removeTree(index, treeIndex)}
                                    className="btn btn-danger btn-sm"
                                  >
                                    Sil
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            addTree(index);
                          }}
                        >
                          <div className="row g-2">
                            <div className="col">
                              <select
                                id={`adi`}
                                className="form-select"
                                name={`adi`}
                                onChange={handleTreeInputChange}
                                value={newTree.adi}
                              >
                                <option defaultValue>--Seçiniz--</option>
                                {agaclar
                                  ? agaclar.map((deger) => (
                                      <option key={deger.id}>
                                        {deger.agacAdi}
                                      </option>
                                    ))
                                  : ""}
                              </select>
                            </div>
                            <div className="col">
                              <input
                                type="number"
                                name="yasi"
                                value={newTree.yasi}
                                onChange={handleTreeInputChange}
                                placeholder="Yaşı"
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="col">
                              <input
                                type="number"
                                name="adeti"
                                value={newTree.adeti}
                                onChange={handleTreeInputChange}
                                placeholder="Adeti"
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="col">
                              <input
                                type="number"
                                name="adetFiyati"
                                value={newTree.adetFiyati}
                                onChange={handleTreeInputChange}
                                placeholder="Adet Fiyatı"
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="col-auto">
                              <button type="submit" className="btn btn-success">
                                Ekle
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="row my-5 d-flex align-items-end">
                      {tasinmazlar.length !== 1 && (
                        <button
                          type="button"
                          onClick={() => tasinmazSil(index)}
                          className="btn btn-danger w-100"
                        >
                          Taşınmazı Sil
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {tasinmazlar.length < 20 && (
              <button
                style={{ height: 100 }}
                onClick={tasinmazEkle}
                className="btn btn-primary mt-3"
              >
                Taşınmaz Ekle
              </button>
            )}
          </div>

          <div className="row">
            <div className="col-3">
              <Link to="/cddosyabilgileri">
                <button className="btn btn-success btn-lg mt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                    />
                  </svg>{" "}
                  Dosya Bilgileri
                </button>
              </Link>
            </div>
            <div className="col-3"></div>

            <div className="col-6">
              <Link to="">
                <button
                  onClick={generateDocx}
                  className="btn btn-warning  btn-lg mt-5"
                  style={{
                    width: "300px",
                    height: "100px",
                    fontWeight: "bold",
                    fontSize: "40px",
                    border: "1px solid",
                  }}
                >
                  RAPOR YAZ
                </button>
              </Link>
            </div>
          </div>
        </div>
      </GlobalProvider>
    </>
  );
}
